import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=9ac9433e"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=9ac9433e&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/alidata/server/jenkins/workspace/sunion-test-web-os/03SRC/web-os/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ac9433e')) {
      api.createRecord('9ac9433e', component.options)
    } else {
      api.reload('9ac9433e', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=9ac9433e", function () {
      api.rerender('9ac9433e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/layout.vue"
export default component.exports